import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';

import { Dimensions } from 'src/app/_charting/models/dimensions.type';
import { Scale } from '../../../models/scale.type';

@Component({
    selector: '[aaGridHor]',
    templateUrl: './grid-hor.component.html',
    styleUrls: [
        './grid-hor.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GridHorComponent implements OnChanges
{
    @Input() dimensions: Dimensions;
    @Input() scale: Scale;
    public ticks: number[] | Date[];

    ngOnChanges (): void
    {
        this.update();
    }

    update ()
    {
        if (!this.dimensions || !this.scale)
        {
            return;
        }

        const numberOfTicks = this.dimensions.boundedHeight / 50;

        this.ticks = this.scale
            .ticks(numberOfTicks)
            .slice(1);
    }
}
